/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  red_10: '#fce3e3',
  red_20: '#fabebe',
  red_30: '#f79999',
  red_40: '#f27474',
  red_50: '#eb4d4d',
  red_60: '#db2929',
  red_70: '#c71818',
  red_80: '#ad0e0e',
  red_90: '#940909',
  red_100: '#7d0606',

  a11y_text_light: [60, 70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/red.js